import { request } from '@/utils/request';

import {
  SearchRequest,
  SearchResponse,
} from './Search.types';

export const api = {
  getSearchResults: (params: SearchRequest) => request.get<SearchResponse>('/search', {
    params,
    withCredentials: false,
  }, true),
};
